import { extractTags } from "./propertyExtraction";
import { styleBySection } from "./util/stepSectionStyle";
import { classifyRmRestriction } from "./util/restrictionClass.mjs";
import { RM_WIDTHS, restrictionStyles } from "./util/restrictionStrokes";
import { roadClass, roadClassStroke } from "./util/roadClass";

// The "Restrictions" view of the RM and OSMLR rows (OSMLR is RMLR with an OSM source,
// same spec): the former HOV and Vehicle Access views in one. Every LR section gets
// its most restrictive lane's access class and its HOV state
// (util/restrictionClass.mjs), drawn exactly as the LM layers draw the same
// restriction (util/restrictionStrokes.js).

export function getSDLaneRestrictionStyleNormal(feature) {
  return getRestrictionStyle(feature, false, false);
}

export function getSDLaneRestrictionStyleClick(feature) {
  return getRestrictionStyle(feature, true, false);
}

export function getSDLaneRestrictionStyleHover(feature) {
  return getRestrictionStyle(feature, false, true);
}

function getRestrictionStyle(feature, click, hover) {
  const { color, width, zIndex } = roadClassStroke(roadClass(feature));
  const plain = { zIndex, strokes: [{ color, width }] };
  return styleBySection(
    feature,
    extractTags(feature),
    classifyRmRestriction,
    (restriction, geometry) =>
      restrictionStyles(restriction, geometry, {
        plain,
        widths: RM_WIDTHS,
        click,
        hover,
      }),
  );
}
